var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body1"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("CURRICULUM LEVELS")]),_vm._v(" "),_c('img',{staticClass:"img",attrs:{"src":require("../../assets/curriculum-04.png")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d21281d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/curriculum/e-body2.vue
// module id = 212
// module chunks = 0